import { Route, Routes } from 'react-router-dom';

import CampaignActionsContext from '@/src/modules/CampaignsModule/contexts/CampaignActionsContext';
import ActionsLayout from '@/src/modules/CampaignsModule/layouts/ActionsLayout';
import CampaignActionsLayout from '@/src/modules/CampaignsModule/layouts/CampaignActionsLayout';
import CampaignMainLayout from '@/src/modules/CampaignsModule/layouts/CampaignMainLayout';
import CampaignsLayout from '@/src/modules/CampaignsModule/layouts/CampaignsLayout';
import { ActionContent } from '@/src/modules/CampaignsModule/screens/ActionContent';
import { CampaignActionsMain } from '@/src/modules/CampaignsModule/screens/CampaignActionsMain';
import { CampaignsMain } from '@/src/modules/CampaignsModule/screens/CampaignsMain';

import ReportCampaign from '@/modules/CampaignsModule/screens/CampaignReport';

export const CampaignsModuleRouter = () => (
  <CampaignMainLayout>
    <Routes>
      <Route element={<CampaignsLayout />} path="/">
        <Route index element={<CampaignsMain />} />
      </Route>
      <Route element={<CampaignActionsLayout />} path="/:id">
        <Route
          index
          element={
            <CampaignActionsContext>
              <CampaignActionsMain />
            </CampaignActionsContext>
          }
        />
        <Route element={<ReportCampaign />} path="report" />
      </Route>
      <Route element={<ActionsLayout />} path="/:campaignId">
        <Route element={<ActionContent />} path=":actionType/:actionId" />
      </Route>
    </Routes>
  </CampaignMainLayout>
);
